import { render, staticRenderFns } from "./WashingOrder.vue?vue&type=template&id=5ac8b211&scoped=true"
import script from "./WashingOrder.vue?vue&type=script&lang=js"
export * from "./WashingOrder.vue?vue&type=script&lang=js"
import style0 from "./WashingOrder.vue?vue&type=style&index=0&id=5ac8b211&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac8b211",
  null
  
)

export default component.exports